var upsellings = {
    init: function () {
        upsellings.bindingAddUpselling();
        upsellings.bindingDelUpselling();

        if ($(".badge-danger").length) {
            $("input[name='promocode']").addClass('border-danger');
        }
    },
    bindingAddUpselling: function () {
        $(".add-upselling").off("Click").on("click", function (e) {
            e.preventDefault();
            $(this).prop("disabled", true);

            var $this = $(this);
            var dataForm = $('#basicdata').serializeArray();

            dataForm.push({
                name: "idupsellingshotel",
                value: $this.data("idupsellingshotel")
            }, {
                name: "promocode",
                value: $("input[name='promocode']").val()
            }, {
                name: "operation",
                value: "add"
            });


            if ($('#num-parking').length) {
                dataForm.push({
                    name: "num-parking",
                    value: $('#num-parking').val()
                });
            }

            var sendPost = true;
            if ($this.data("idupsellingshotel") == "promocode" && !$.trim($("input[name='promocode']").val()).length) {
                sendPost = false;
                $("input[name='promocode']").val("").addClass('border-danger');
                $this.prop("disabled", false);
            }
            if ($this.data("idupsellingshotel") == "promocode" && $.trim($("input[name='promocode']").val()).length) {
                $("input[name='promocode']").removeClass('border-danger');
            }

            if (sendPost) {
                $.post("/buscar/updateupselling/", dataForm, function (data) {
                    if (!data.isOK) {
                        if (data.redirectTo) {
                            window.location.href = data.redirectTo;
                        }
                        return;
                    }

                    if (data.type == "promocode" || data.type == "redirectTo") {
                        window.location.href = data.redirectTo;
                    } else {
                        $("#upselling-" + data.idUpsellingsHotel).find(".badge-success").removeClass('d-none');
                        $("#upselling-" + data.idUpsellingsHotel).find(".add-upselling").addClass('d-none').data("idresultadosupselling", data.idResultadosUpselling);
                        $("#upselling-" + data.idUpsellingsHotel).find(".del-upselling").prop('disabled', false).removeClass('d-none').data("idresultadosupselling", data.idResultadosUpselling);
                        $("#detalles-upsellings").append("<div id='resultado-upselling-" + data.idResultadosUpselling + "' class='d-flex justify-content-between'>" + "<p>" + data.nameUpselling + "</p>" + "<p>" + data.priceUpselling + "€</p></div>");
                        $(".total span").text(data.totalPrice + "€");

                        document.querySelector("#upselling-collapse").classList.add("show");
                    }

                }, "json").fail(function () {
                    // alert("error inesperado");
                });
            }
        });
    },
    bindingDelUpselling: function () {
        $(".del-upselling").off("Click").on("click", function (e) {
            e.preventDefault();
            $(this).prop("disabled", true);
            var $this = $(this);
            var dataForm = $('#basicdata').serializeArray();

            dataForm.push({
                name: "idresultadosupselling",
                value: $this.data("idresultadosupselling")
            }, {
                name: "idupsellingshotel",
                value: $this.data("idupsellingshotel")
            }, {
                name: "promocode",
                value: ""
            }, {
                name: "operation",
                value: "del"
            });

            $.post("/buscar/updateupselling/", dataForm, function (data) {
                if (!data.isOK) {
                    if (data.redirectTo) {
                        window.location.href = data.redirectTo;
                    }
                    return;
                }

                if (data.type == "promocode" || data.type == "redirectTo") {
                    window.location.href = data.redirectTo;
                } else {
                    $("#upselling-" + data.idUpsellingsHotel).find(".badge-success").addClass('d-none');
                    $("#upselling-" + data.idUpsellingsHotel).find(".del-upselling").addClass('d-none').data("idresultadosupselling", "");
                    $("#upselling-" + data.idUpsellingsHotel).find(".add-upselling").prop('disabled', false).removeClass('d-none').data("idresultadosupselling", "");
                    $("#resultado-upselling-" + data.idResultadosUpselling).remove();
                    $(".total span").text(data.totalPrice + "€");

                    document.querySelector("#upselling-collapse").classList.add("show");
                }
            }, "json").fail(function () {
                // alert("error inesperado");
            });
        });
    },
    // bindingScroll: function () {
    //     var observer = new IntersectionObserver(function(entries) {
    //         // no intersection with screen
    //         console.log(entries[0].intersectionRatio);
    //         if(entries[0].intersectionRatio === 0) {
    //             document.querySelector("#upsellings-collapse").classList.remove("show");
    //             // document.querySelector(".sticky-details").style["margin-top"] = "0";
    //         }
    //         // fully intersects with screen
    //         else if(entries[0].intersectionRatio === 1) {
    //             document.querySelector("#upselling-collapse").classList.add("show");
    //             // document.querySelector(".sticky-details").style["margin-top"] = "-48px";
    //         }
    //     }, { threshold: [0,1] });

    //     observer.observe(document.querySelector(".calamar"));
    // }
};


$(function () {

    upsellings.init();

    $('.upselling-header a').on('click', function (e) {
        e.preventDefault();
        if ($('.upselling-header a svg').hasClass('open')) {
            $('.upselling-header a svg').removeClass('open').addClass('close');
        } else {
            $('.upselling-header a svg').removeClass('close').addClass('open');
        }
    });
});